<template>
    <!-- busy -->
    <template v-if="semaphore > 0">
        <i class="fa fa-spinner fa-spin"></i>
    </template>

    <!-- ready -->
    <template v-else>
        <!-- Headline -->
        <h3 :class="[config.jobsHeadlineClass]">
            {{ content.headlineLatestJobs }} {{ locationsTerm }}.
        </h3>
        <!-- Copy -->
        <div :class="[config.jobsCopyClass]" v-html="content.copy"></div>
        <!-- Jobs-List -->
        <ul :class="[
            'list-unstyled',
            config.jobsListClass
        ]">
            <li :class="[config.jobsListClass]" v-for="job in jobs">
                <a :href="'/' + config.job_detail_url! + job.slug!" :class="['position-relative', config.jobsListLinkClass]">{{ job.title }}</a>
            </li>
        </ul>
    </template>
</template>

<script lang="ts" setup>
import axios, {type AxiosResponse} from "axios";
import {ref} from "vue";

interface Props {
    locations: Array<string>;
    routes: any;
    content: any;
    config: any;
    styles: any;
}

type JobData = Record<string, any>;

const props = defineProps<Props>();

const limit = props.content.limit || 5;

// make readable term from array
const locationsTerm = props.locations.length <= 1 ?
    props.locations[0] :
    props.locations.slice(0, props.locations.length - 1).join(', ') + ' & ' + props.locations[props.locations.length - 1];

const semaphore = ref(1);

const jobs = ref<Array<JobData>>([]);

axios
    .post(props.routes.search!, {}, {
        params: {
            'contact-locations': props.locations,
            'pagination': 'offset',
            'per-page': limit,
        }
    })
    .then((response: AxiosResponse<Array<JobData>>) => {
        jobs.value = response.data.slice(0, limit);
        semaphore.value--;
    });

</script>
